"use client";
import React from "react";
import { useDictionary } from "../../context/dictionaryProvider";

const EnquiryTypeToggle = ({ isCorporate, onChange }) => {
  const dict = useDictionary();
  const enquiryType = dict?.form?.enquiryType;

  return (
    <div className="mt-8 mb-8">
      <p className="mb-3 text-sm font-bold text-[#303030]">
        {enquiryType?.label || "Enquiry Type"}
      </p>
      <div
        dir="ltr"
        className="relative inline-grid w-full max-w-[360px] grid-cols-2 overflow-hidden rounded-full bg-white p-1.5 shadow-[0_12px_30px_rgba(0,150,172,0.08)] ring-1 ring-[#e0f4f7]"
      >
        <div
          className={`pointer-events-none absolute top-1.5 bottom-1.5 w-[calc(50%-0.375rem)] rounded-full bg-[#0096ac] shadow-[0_10px_24px_rgba(0,150,172,0.28)] transition-transform duration-300 ease-out ${
            isCorporate ? "translate-x-[calc(100%+0.375rem)]" : "translate-x-0"
          }`}
        />

        <button
          id="enquiry-type-individual"
          type="button"
          role="switch"
          aria-checked={!isCorporate}
          data-enquiry-type="individual"
          onClick={() => onChange(false)}
          className={`relative z-10 flex items-center justify-center gap-2.5 rounded-full px-4 py-3 text-base font-semibold transition-colors duration-300 ${
            !isCorporate ? "text-white" : "text-[#5d74a6]"
          }`}
        >
          <span className="h-3.5 w-3.5 rounded-full bg-white" />
          <span>{enquiryType?.individual || "Individual"}</span>
        </button>

        <button
          id="enquiry-type-corporate"
          type="button"
          role="switch"
          aria-checked={isCorporate}
          data-enquiry-type="corporate"
          onClick={() => onChange(true)}
          className={`relative z-10 flex items-center justify-center gap-2.5 rounded-full px-4 py-3 text-base font-semibold transition-colors duration-300 ${
            isCorporate ? "text-white" : "text-[#5d74a6]"
          }`}
        >
          <span className="h-3.5 w-3.5 rounded-full bg-white" />
          <span>{enquiryType?.corporate || "Corporate"}</span>
        </button>
      </div>
    </div>
  );
};

export default EnquiryTypeToggle;
